import RefreshIcon from '@mui/icons-material/Refresh';
import { Button, Paper, Stack, Typography } from '@mui/material';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

interface NotificationEmptyStateProps {
  onRefresh: () => void;
}

export const NotificationEmptyState = memo(function NotificationEmptyState({
  onRefresh,
}: NotificationEmptyStateProps) {
  const { t } = useTranslation('entity-portal');

  return (
    <Paper
      variant="outlined"
      sx={{ p: 4, textAlign: 'center', borderStyle: 'dashed' }}
      role="status"
    >
      <Stack spacing={2} alignItems="center">
        <Typography variant="h6">
          {t('notificationCenter.emptyTitle')}
        </Typography>
        <Typography color="text.secondary">
          {t('notificationCenter.emptyDescription')}
        </Typography>
        <Button
          variant="outlined"
          startIcon={<RefreshIcon />}
          onClick={onRefresh}
        >
          {t('notificationCenter.refresh')}
        </Button>
      </Stack>
    </Paper>
  );
});
